<div style="background-image: url('assets/takiecom_bg.jpg');background-size: cover;" class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="flex flex-column align-items-center justify-content-center" style="transform: translateY(-100px);">
        <!-- <img src="assets/taki_ecom.png" alt="Dashboard Managment logo" class="mb-2 w-30rem flex-shrink-0">                 -->
        <div>
            <div class="w-full surface-card py-6 px-5 sm:px-6" style="border-radius:5px;position: relative;background-color: rgba(225,225,225,85%) !important;;">
                <!-- <choose-language style="position: absolute;right: 28px;top: 30px;"></choose-language> -->
                <div class="mb-2 text-center">
                    <img src="assets/taki_ecom.png" alt="Dashboard Managment logo" class="w-10rem flex-shrink-0">
                    <!-- <div class="text-900 text-4xl font-medium mb-2 text-center">{{tranService.translate('login.label.title')}}</div> -->
                    <!-- <p>
                        <span>Power by Smart Data</span>
                    </p> -->
                </div>

                <div>
                    <label for="email1" class="block text-900 text-xl font-medium mb-2">{{tranService.translate("login.label.email")}}</label>
                    <input id="email1" type="text" [(ngModel)]="loginInfo.email" [placeholder]="tranService.translate('login.label.email')" pInputText class="w-full md:w-30rem mb-5" style="padding:1rem">

                    <label for="password1" class="block text-900 font-medium text-xl mb-2">
                        <span>{{tranService.translate("login.label.password")}}</span>&nbsp;
                        <span><a class="font-medium no-underline ml-2 text-right cursor-pointer" (click)="showDialogForgotPass()" style="color: var(--primary-color)">{{tranService.translate("login.label.forgotPass")}}?</a></span>
                    </label>
                    <p-password id="password1" [(ngModel)]="loginInfo.password" [feedback]=false [placeholder]="tranService.translate('login.label.password')" [toggleMask]="true" styleClass="mb-5" inputStyleClass="w-full p-3 md:w-30rem" (keyup.enter)="login(loginInfo)"></p-password>

                    <div class="flex align-items-center justify-content-between mb-0 gap-5">
                        <div class="flex align-items-center">
                        </div>
                    </div>
                    <button type="submit" pButton pRipple [label]="tranService.translate('login.label.signIn')" class="w-full p-3 text-xl bg-gray-800"  (click)="login(loginInfo)"></button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- dialog -->
<div class="flex justify-content-center dialog-forgot-pass">
    <p-dialog [header]="tranService.translate('login.label.forgotPass')" [(visible)]="isShowDialogForgotPass" [modal]="true" [style]="{ width: '500px' }" [draggable]="false" [resizable]="false">
        <form [formGroup]="formForgot" (ngSubmit)="resetPasswordEmail(forgotInfo)">
            <div class="field">
                <input id="email1" type="text" [(ngModel)]="forgotInfo.email"
                [placeholder]="tranService.translate('login.label.email')"
                pInputText
                formControlName="email"
                class="w-full mb-5"
                [required]="true"
                [maxLength]="255"
                pattern="^[a-z0-9]+[a-z0-9\-\._]*[a-z0-9]+@([a-z0-9]+[a-z0-9\-\._]*[a-z0-9]+)+(\.[a-z]{2,})$"
                >
            <!-- error email -->
            <div class="w-full field grid text-error-field">
                <div class="col">
                    <small class="text-red-500" *ngIf="formForgot.controls.email.dirty && formForgot.controls.email.errors?.required">{{tranService.translate("global.message.required")}}</small>
                    <small class="text-red-500" *ngIf="formForgot.controls.email.errors?.maxLength">{{tranService.translate("global.message.maxLength",{len:255})}}</small>
                    <small class="text-red-500" *ngIf="formForgot.controls.email.errors?.pattern">{{tranService.translate("global.message.invalidEmail")}}</small>
                </div>
            </div>

            <button type="submit" pButton pRipple [label]="tranService.translate('login.label.resetPass')" class="w-full p-3 text-md bg-blue-800"></button>
            </div>
        </form>
    </p-dialog>
</div>

<!-- dialog captcha -->
<div class="flex justify-content-center dialog-forgot-pass">
    <p-dialog header="Captcha" [(visible)]="isShowDialogCaptcha" [modal]="true" [style]="{ width: '500px' }" [draggable]="false" [resizable]="false">
        <div class="flex flex-row justify-content-center">
            <!-- <captcha-custom [callBackSuccess]="handleLogin.bind(this)" [controller]="captchaControl"></captcha-custom> -->
            <re-captcha
                siteKey="6LdqjkMqAAAAAJfKpxmoMy98dkQYkRXIlFt7X2aU"
                (resolved)="handleCaptchaResolved($event)"
            ></re-captcha>
        </div>
    </p-dialog>
</div>
